import React from 'react';

const StandardFormUploadInstructions = ()=> {
  return (
    <div>
      <div className="file-uploader__info-title">
        Please upload the following documents:
      </div>
      <div>
        &bull; Signed application
      </div>
      <div>
        &bull; Last 3 months of complete bank statements
      </div>
    </div>
  );
};

export default StandardFormUploadInstructions;
